import { Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/lib/constants/routes';
import { LinkStatusCard } from '@/components/common/LinkStatusCard';
import { CREATE_STARTUP_STRINGS } from '../constants';

/**
 * Shown by `CreateStartupPage` in place of the 4-step wizard when
 * `useStartupEligibility` reports WORK_EMAIL_REQUIRED (FR-14, MYN-76) - the
 * account's own email is personal/social, so the guided email-replacement
 * flow must complete before startup creation can continue. Mirrors
 * `StartupAlreadyExistsState`'s structure and page slot.
 *
 * Does not open `ReplaceEmailDialog` itself - that action lives only on the
 * `/me` Email card (Individual-only). The primary action routes there
 * instead, where the Update Email button is visible straight away.
 */
export function EmailReplacementRequiredState({ inline = false }: { inline?: boolean } = {}) {
  const S = CREATE_STARTUP_STRINGS;
  const navigate = useNavigate();

  return (
    <LinkStatusCard
      icon={<Mail size={32} />}
      heading={S.WORK_EMAIL_REQUIRED_TITLE}
      body={S.WORK_EMAIL_REQUIRED_DESCRIPTION}
      ctaLabel={S.WORK_EMAIL_REQUIRED_DASHBOARD_ACTION}
      ctaTo={ROUTES.DASHBOARD}
      ctaVariant="link"
      inline={inline}
      primaryAction={{
        label: S.WORK_EMAIL_REQUIRED_ACTION,
        onClick: () => navigate(ROUTES.ACCOUNT),
      }}
    />
  );
}
